<template>
  <svg
    width="5"
    height="5"
    viewBox="0 0 16 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2.09553L8 0L6 2.09553L3 0V7.33435C3 10.2681 5.2 12.5732 8 12.5732C10.8 12.5732 13 10.2681 13 7.33435V0L10 2.09553ZM8 10.4776C6.3 10.4776 5 9.11554 5 7.33435H11C11 9.11554 9.7 10.4776 8 10.4776Z"
      fill="black"
    />
    <path
      d="M8.00012 17.7069L11.4001 14.1445C10.4001 13.8302 9.30013 13.6206 8.00012 13.6206C6.70011 13.6206 5.6001 13.8302 4.6001 14.1445L8.00012 17.7069Z"
      fill="black"
    />
    <path
      d="M3.1 14.7715C1.2 15.9241 0 17.7054 0 19.9059V22.0015H7V18.9628L3.1 14.7715Z"
      fill="black"
    />
    <path
      d="M12.9 14.7715L9 18.9628V22.0015H16V19.9059C16 17.7054 14.8 15.9241 12.9 14.7715Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconUser',
};
</script>
